import React from 'react'
import Entity from '.'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
const StickyEntity = ({ gridSizes = { entity: { xs: 12, sm: 6, md: 4 } }, module_name }) => {
  const { selectedSupplierData } = useSelector(
      (state) => state.entityReducer
  );
  const isEntityEnabled = selectedSupplierData?.entity_enabled;
  // if (!isEntityEnabled) {
  //   return null;
  // }
  return (
    <Box sx={{ 
        display: 'flex', 
        justifyContent:'end', 
        p: { xs: 2, md: 0 },
        mr: { xs: 0, md: 0 }, 
        ml: {xs: 0, md: 2},
        pb: { xs: 0, md: 0 },
        position: {xs: 'fixed', md: 'relative'}, 
        top: {xs: '88px', md: 0}, 
        left: {xs: 0, md: 'auto'},
        right: {xs: 0, md: 'auto'},
        zIndex: {xs: 1000, md: 'auto'}, 
        boxShadow: {xs: '0px 2px 8px 0px #0000001A', md: 'none'},
        background: {xs: '#FAFAFA', md: 'transparent'},
      }}>
        <Entity
          desktopmb = {0}
          supplierLabel="Manufacturer"
          entityLabel="SAP Code*"
          forceRefresh={false}
          gridSizes={gridSizes}
          module_name = {module_name}
        />
      </Box>
  )
}

export default StickyEntity